// components/TruncatedTextWithTooltip.jsx

import React from "react";

const isRTL = (text) => /^[\u0600-\u06FF]/.test(text);

const TruncatedTextWithTooltip = ({ text, maxLength, className = "" }) => {
  const rtl = isRTL(text);
  const dir = rtl ? "rtl" : "ltr";

  return (
    <div className={`group relative ${maxLength ? `max-w-[${maxLength}ch]` : "w-full"} `}>
      {/* Display Truncated Text */}
      <div
        dir={dir}
        className={`truncate ${className}`}
        style={{
          maxWidth: "100%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          direction: dir,
        }}
      >
        {text}
      </div>

      {/* Custom Tooltip */}
      <div
        className={`absolute -top-8 left-1/2 z-20 w-max -translate-x-1/2 scale-0 rounded bg-gray-800 px-2 py-1 text-xs text-white opacity-0 transition-all duration-200 group-hover:scale-100 group-hover:opacity-100`}
        dir={dir}
      >
        {text}
      </div>
    </div>
  );
};

export default TruncatedTextWithTooltip;
